function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "social-soundcloud",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "social-circle",
    cx: 22,
    cy: 22,
    r: 22,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M8,27.13a.94.94,0,0,0,.38.81,1,1,0,0,0,.81.19.9.9,0,0,0,.57-.29,1.2,1.2,0,0,0,.16-.71v-3.9a1,1,0,0,0-.28-.71A.92.92,0,0,0,9,22.24a.9.9,0,0,0-.67.29,1,1,0,0,0-.28.71v3.89Zm3,1.66a.68.68,0,0,0,.27.58,1.13,1.13,0,0,0,.68.19,1.15,1.15,0,0,0,.7-.19.68.68,0,0,0,.27-.58V19.72a1,1,0,0,0-.28-.69.92.92,0,0,0-.68-.29.9.9,0,0,0-.67.29,1,1,0,0,0-.28.69v9.07h0Zm3,.43a.67.67,0,0,0,.27.58,1.19,1.19,0,0,0,.7.2,1.13,1.13,0,0,0,.68-.2.67.67,0,0,0,.27-.58V20.94a1,1,0,0,0-.28-.71.89.89,0,0,0-.67-.29.93.93,0,0,0-.69.29,1,1,0,0,0-.29.71v8.28h0Zm3,0Q17,30,18,30t1-.74V15.84a1.09,1.09,0,0,0-.67-1.28.91.91,0,0,0-.85.26,1.28,1.28,0,0,0-.42,1V29.26h0Zm3,.39V15.05a.76.76,0,0,1,.4-.83A7.24,7.24,0,0,1,22.17,14a7.46,7.46,0,0,1,3.71,1,7.75,7.75,0,0,1,2.78,2.64,8,8,0,0,1,1.23,3.68A4.16,4.16,0,0,1,31.58,21,4.21,4.21,0,0,1,34.7,22.3a4.6,4.6,0,0,1,0,6.4A4.19,4.19,0,0,1,31.6,30H20.27a.3.3,0,0,1-.18-.15.41.41,0,0,1-.06-.19h0Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.b3e3240dbfbcf14df2956b9768f5a052.svg";
export { ForwardRef as ReactComponent };